import React, { Component, useEffect, useState } from "react";

//custom
import { useParams, Navigate, useNavigate } from "react-router-dom";
//import axios
import axios from "axios";

//utils
import {
  check_authorized,
  signoutuser_confirm,
  isloginuser,
  get_userseckey,
  getuniquedeviceid,
  signoutuser,
} from "../../utils/Helper/CheckAuth";
import {
  showLoading,
  stopLoading,
  sent_clean_var,
  scroll_to_top,
  gotohome,
} from "../../utils/Helper/JSHelper";
import CallURL from "../../utils/API/CallURL";

//components
import Navigation from "../../components/Navigation/Navigation";
//componentsAdmin
import AdminMenu from "../../componentsAdmin/AdminMenu/AdminMenu";
import ContentCard from "../../componentsAdmin/ContentCard/ContentCard";

function ContentList() {
  // Get ID from URL
  const params = useParams();

  const topic_id = params.topicid;

  //temp variable
  const [list_temp_load, set_list_temp_load] = useState([]);

  //myadmin variable
  const [is_admin, set_is_admin] = useState("no");

  //topic variable
  const [topic_name, set_topic_name] = useState("");
  const [item_list, set_item_list] = useState([]);

  //unique_key_count
  var unique_key_count = 0;

  //starting on mount
  useEffect(() => {
    //change background color
    document.body.style = "background: white;";

    //isloginuser
    if (isloginuser()) {
      check_is_admin();
    }

    //if login check_authorized
    check_authorized("user");
  }, [list_temp_load]);

  //check user admin or not
  function check_is_admin() {
    //showLoading
    showLoading();
    // Create an object of formData
    const formData = new Object();
    // Update the formData object
    formData.secuserkey = get_userseckey();
    formData.deviceid = getuniquedeviceid();
    // Send formData object
    axios
      .post(CallURL.isadmin, formData)
      .then((response) => {
        stopLoading();
        //console.log(response);
        //alert(response.data.apires);
        if (response.data.apires == "yes") {
          set_is_admin("yes");
        } else {
          set_is_admin("no");
        }
        //check_valid_topic
        check_valid_topic();
      })
      .catch((error) => {
        stopLoading();
        console.log(error);
        set_is_admin("no");
      });
  }

  //check topic valid or not
  function check_valid_topic() {
    //showLoading
    showLoading();

    // Create an object of formData
    const formData = new Object();

    //extra authorized user
    formData.secuserkey = get_userseckey();
    formData.deviceid = getuniquedeviceid();

    //extra variable
    formData.topic_id = topic_id;

    // Send formData object
    axios
      .post(CallURL.check_valid_topic, formData)
      .then((response) => {
        stopLoading();
        //console.log(response);
        //alert(response.data.apires)
        if (response.data.apires == "success") {
          //set_course_name
          set_topic_name(response.data.topic_name);
          //load_itemlist
          load_itemlist();
        } else if (response.data.apires == "no_found") {
          gotohome();
        } else {
          alert("Something went wrong. Try again.");
        }
      })
      .catch((error) => {
        console.log(error);
        stopLoading();
        alert("Something went wrong. Try again.");
      });
  }

  //load_contentlist
  function load_itemlist() {
    //showLoading
    showLoading();
    //reset variable
    set_item_list([]);
    unique_key_count = 0;

    // Create an object of formData
    const formData = new Object();

    //extra authorized user
    formData.secuserkey = get_userseckey();
    formData.deviceid = getuniquedeviceid();

    //extra variable
    formData.topic_id = topic_id;

    // Send formData object
    axios
      .post(CallURL.load_content_list, formData)
      .then((response) => {
        stopLoading();
        //console.log(response);
        //alert(response.data.apires)
        if (response.data.apires == "success") {
          //set topic_list_for
          var itemlist_temp = [];
          for (var i = 0; i < response.data.rows.length; i++) {
            var row = response.data.rows[i];
            //row.push({ username: "rushi " + i });
            //add into array
            itemlist_temp.push(row);
          }
          //alert("saved profile scroll");
          //alert(JSON.stringify(itemlist_temp));
          add_arr(itemlist_temp);
        } else if (response.data.apires == "no_found") {
          document.getElementById("div_no_item_found").style.display = "none";
          document.getElementById("div_no_item_found").style.display = "block";
        } else {
          alert("Something went wrong. Try again.");
        }
      })
      .catch((error) => {
        console.log(error);
        stopLoading();
        alert("Something went wrong. Try again.");
      });
  }
  const add_arr = (itemlist_temp) => {
    //alert("hi" + JSON.stringify(itemlist_temp));
    //appende to all previous
    set_item_list((prevState) => [...prevState, ...itemlist_temp]);
  };

  //no_user_found_return
  function no_item_found_return() {
    if (item_list.length == 0) {
      return (
        <div className="no_found_div">
          <br />
          <center>
            <font className="no_found_font">
              {topic_name}'s content information not found.
            </font>
          </center>
        </div>
      );
    }
  }

  //is new item added
  function added_new_item() {
    //load_itemlist
    load_itemlist();
  }

  function showTopicList() {
    return ( 
      <>
        <div className="container">
          <div className="row">
            <div className="col s12 m12 l12"></div>
            <div
              className="col s12 m12 l12 app_view_contain_remove"
              style={{ wordBreak: "break-word" }}
            >
              <center>
                <font className="font_sub_title">{topic_name}</font>
              </center>
              <hr />
              <br />
              <div style={{ wordBreak: "break-word", width: "100%" }}>
                {(() => {
                  if (is_admin == "yes") {
                    return (
                      <ContentCard
                        topic_id={topic_id}
                        afteradd={added_new_item}
                        edit_add="add"
                        is_admin={is_admin}
                        item_info={[]}
                      />
                    );
                  }
                })()}
                <div className="watermark_body center">
                  {item_list.map((item) => {
                    unique_key_count++;
                    const index = Number(unique_key_count - 1);
                    const user_unique_key = unique_key_count + "_item_list";
                    return (
                      <div key={user_unique_key} id={user_unique_key}>
                        <ContentCard
                          topic_id={topic_id}
                          afteradd={added_new_item}
                          edit_add="edit"
                          is_admin={is_admin}
                          item_info={item}
                        />
                      </div>
                    );
                  })}
                </div>
                <div id="div_no_item_found" style={{ display: "none" }}>
                  {no_item_found_return()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  return (
    <React.Fragment>
      <div
        className="fixed-action-btn"
        style={{
          marginBottom: "-15px",
          bottom: "70px",
          right: "10px",
          left: "auto",
        }}
      >
        <a
          className="btn-floating z-depth-1 blue"
          onClick={() => scroll_to_top("smooth")}
        >
          <i className="fa fa-arrow-up"></i>
        </a>
      </div>
      {showTopicList()}
      <Navigation link_type="other" />
    </React.Fragment>
  );
}

export default ContentList;
